import { DaoService } from "./DaoService";

class UserService extends DaoService {
    static CLASS_NAME = 'App\\Models\\User'; 

    static getInstance() {
        return super.getInstance('user');
    }

    login(data) {
        return UserService.post(`${this.prefix}/login`, data);
    }

    getCurrentUser() {
        return UserService.get(`${this.prefix}/current`);
    }

    logout() {
        return UserService.post(`${this.prefix}/logout`);
    }

    resetPassword(token, data) {
        return UserService.post(`${this.prefix}/reset-password/${token}`, data);
    }

    enable(idOrUid) {
        return UserService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid, data) {
        return UserService.post(`${this.prefix}/${idOrUid}/disable`, data);
    }

    linkGroupes(uid, data) {
        return UserService.post(`${this.prefix}/${uid}/link-groupes`, data);
    }

    findLinkedGroupes(uid) {
        return UserService.get(`${this.prefix}/${uid}/linked-groupes`);
    }

    all() {
        return UserService.get(`${this.prefix}/all`);
    }

    getUserIdsAttachedToGroup(uid) {
        return UserService.get(`${this.prefix}/${uid}/ids-attached-groupe`);
    }

    search(data) {
        return UserService.post(`${this.prefix}/search`, data);
    }

    verifyToken(data) {
        return UserService.post(`${this.prefix}/verify-token`, data);
    }

    changePassword(data) {
        return UserService.post(`${this.prefix}/change-password`, data);
    }
}


export default UserService;